/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_ReceivingInputs */

const en_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receiving project from Iconik...`)
};

const fr_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reception du projet depuis Iconik...`)
};

const de_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalt eines Projekts von Iconik...`)
};

const it_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricezione del progetto da Iconik...`)
};

const ru_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получение проекта от Iconik...`)
};

const es_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibiendo proyecto de Iconik...`)
};

const zh_cn2_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在接收来自 Iconik 的项目……`)
};

const ja_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik からプロジェクトを受け取っています...`)
};

const hi_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik से प्रोजेक्ट प्राप्त हुआ...`)
};

const pt_pt2_iconik_import_status_receiving = /** @type {(inputs: Iconik_Import_Status_ReceivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebendo projeto da Iconik...`)
};

/**
* | output |
* | --- |
* | "Receiving project from Iconik..." |
*
* @param {Iconik_Import_Status_ReceivingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_receiving = /** @type {((inputs?: Iconik_Import_Status_ReceivingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_ReceivingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_status_receiving(inputs)
	if (locale === "de") return de_iconik_import_status_receiving(inputs)
	if (locale === "it") return it_iconik_import_status_receiving(inputs)
	if (locale === "ru") return ru_iconik_import_status_receiving(inputs)
	if (locale === "es") return es_iconik_import_status_receiving(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_status_receiving(inputs)
	if (locale === "ja") return ja_iconik_import_status_receiving(inputs)
	if (locale === "hi") return hi_iconik_import_status_receiving(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_status_receiving(inputs)
	return en_iconik_import_status_receiving(inputs)
});